import React from 'react';

// 定义步骤数据项的接口
interface StepItem {
  title?: string;
  title_m?: string;
  description?: string;
  description_m?: string;
}

// 定义步骤数据的接口
interface StepsData {
  title?: string;
  title_m?: string;
  data_array: StepItem[];
}

// 定义组件props的接口
interface StepsPartProps {
  stepsData?: StepsData;
}

const StepsPart: React.FC<StepsPartProps> = ({ stepsData = { data_array: [] } }) => {
  return (
    <div className="w-full px-[14px] md:px-[24px] lg:px-[48px] pb-[40px] md:pb-[60px] lg:pb-[80px] box-border">
      <div className="mb-[16px] md:mb-[24px]">
        <h3 className="text-[24px] md:text-[28px] lg:text-[32px] font-bb leading-[29px] md:leading-[34px] lg:leading-[39px] text-center mb-[16px] md:mb-[20px]">
          {stepsData.title}
        </h3>
      </div>
      <ul className="md:mx-[100px] flex flex-col md:flex-row md:gap-16 justify-between">
        {stepsData.data_array.map((item, index) => (
          <li
            key={index}
            className={`md:w-1/3 bg-[#f4f4f4] rounded-[6px] md:rounded-[8px] px-[12px] md:px-[16px] lg:px-[20px] py-[16px] md:py-[20px] lg:py-[24px] box-border ${
              index === stepsData.data_array.length - 1 ? 'mb-0' : 'mb-[8px] md:mb-0'
            }`}
          >
            <p className="flex justify-start items-start md:items-center md:flex-col">
              <span className="text-[14px] md:text-[18px] lg:text-[18px] font-bb whitespace-nowrap md:mb-12">
                {item.title}
              </span>
              <span className="font-br text-[13px] md:text-[14px] lg:text-[16px] leading-[16px] md:leading-[18px] lg:leading-[20px] ml-[10px] md:ml-0 flex-1 md:text-center">
                {item.description}
              </span>
            </p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default StepsPart;
